import { useQuery } from 'react-query';
import { listDrugs } from 'src/services/api/catalogs';

function useListDrugsCatalog(query, enabled = false) {
  return useQuery(['drugs', query], (key, query) => listDrugs(query), { enabled });
}

export default useListDrugsCatalog;
